import React from 'react';
import Styled from 'styled';
import { Query } from '@apollo/client/react/components';

import LoadingProgress from 'lib/react-router/loading-progress';
import { InterscrollerPlaceholder } from 'lib/google/dfp/ad-units/interscroller';

import ErrorPage from 'four-nets/errors/error-page';
import { ViewerContext } from 'four-nets/user/viewer/viewer';

import TagSlug from './tag-slug/tag-slug';
import query, { InspirationsLoaderQuery, InspirationsLoaderQueryVariables } from './inspirations-loader.graphql';

import defaultStyles from './inspirations-loader.scss';

interface Props {
    styles: typeof defaultStyles;
    inspirationsCount?: number;
}

class InspirationsLoader extends React.PureComponent<Props> {
    static contextType = ViewerContext;

    render() {
        const { styles, inspirationsCount } = this.props;
        return (
            <Query<InspirationsLoaderQuery, InspirationsLoaderQueryVariables>
                query={query}
                variables={{
                    firstImages: 3,
                    inspirationsCount,
                    isAuth: Boolean(this.context?.viewer),
                }}
                fetchPolicy='cache-first'
            >
                {({ loading, error, data }) => (
                    <LoadingProgress loading={loading}>
                        <ErrorPage error={error}>
                            {data && data.tagSlugs ? (
                                <div className={styles.content}>
                                    <ul className={styles.inspirations}>
                                        {data.tagSlugs.edges
                                            ? data.tagSlugs.edges.map((tagSlug, index) =>
                                                  tagSlug && tagSlug.node ? (
                                                      <React.Fragment>
                                                          <li key={tagSlug.node.id} className={styles.inspirationItem}>
                                                              <TagSlug key={tagSlug.node.id} {...tagSlug.node} />
                                                          </li>
                                                          {index === 1 ? (
                                                              <li key={index} className={styles.interscrollerItem}>
                                                                  <InterscrollerPlaceholder />
                                                              </li>
                                                          ) : null}
                                                      </React.Fragment>
                                                  ) : null
                                              )
                                            : null}
                                    </ul>
                                </div>
                            ) : null}
                        </ErrorPage>
                    </LoadingProgress>
                )}
            </Query>
        );
    }
}
export default Styled(defaultStyles)(InspirationsLoader);
